import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartData } from "../redux/actions/cartData";
import { useEffect, useState } from "react";
import { removeFromCart } from "../service/addToCart";
import { fetchWishlistData } from "../redux/actions/wishlistData";
import { addToWishlist } from "../service/addToWishlist";
import { decrementQuantityOfCartProduct, incrementQuantityOfCartProduct } from "../service/Incre&DecrrQuantityINCart";
import { fetchLoggedUser } from "../redux/actions/loggedUserActions";
function formatNumber(value) {
    const num = Number(value);
    return num % 1 === 0 ? num : num.toFixed(2);
  }
export default function CartPage() {
  const navigate=useNavigate();
  const [loading, setLoading] = useState(false);
  
  const getSubtotal = () =>
    cartData.reduce((sum, item) => sum + item.product?.originalPrice * item.quantity, 0);

  const getTotal = () =>
    cartData.reduce((sum, item) => sum + item.product?.discountedPrice * item.quantity, 0);
  
  const handleOnCLickOnAddMoreButton=()=>
  {
      navigate("/");
  }

  const dispatch=useDispatch();

  const { user, error } = useSelector(
      (state) => state.loggedUserState
  );
  
  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchLoggedUser());  
    };
    fetchData();
  }, [dispatch]);

  const {cartData=[], carterror,}=useSelector((state)=>state.cartState);

  const {wishlistData=[], wishlisterror,}=useSelector((state)=>state.wishlistState);
    
    useEffect(()=>{            
      dispatch(fetchWishlistData());          
    },[dispatch]);

    const isInWishlist = (productId) => {
      return wishlistData.some(item => item.product.id === productId);
    };
  
  useEffect(()=>{     
      try {
            setLoading(true);
            dispatch(fetchCartData());
          } finally {
            setLoading(false);
          }
  },[dispatch]);

  const RemoveFromCart=(productId,selectedColor,selectedSize)=>{
    dispatch(removeFromCart(productId,selectedColor,selectedSize));
  }

  const MOveTOWishlist = (productId) => {  
    dispatch(addToWishlist(productId));
    dispatch(removeFromCart(productId));
  };

  const UpdateQuantity = (id, type,selectedColor,selectedSize) => {
    if (type === "increment") {
      dispatch(incrementQuantityOfCartProduct(id,selectedColor,selectedSize));
    } else if (type === "decrement") {
      dispatch(decrementQuantityOfCartProduct(id,selectedColor,selectedSize));
    }
  };

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h2 className="text-2xl font-semibold text-red-600">Access Denied</h2>
        <p className="mt-2 text-gray-600">You must be logged in to view this page.</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          onClick={() => navigate("/login")}
        >
          Go to Login
        </button>
        
      </div>
    );
  }

  if(carterror)
  {
    if(user)
    return(
      <p className="text-red-600">Cart error : {carterror}</p>
    );
  }

  if (loading) {
    return <p className="text-center mt-10">Loading cart products...</p>;
  }

  if(wishlisterror)
  {
    if(user)
    return(
      <p className="text-red-600">Wishlist error : {wishlisterror}</p>
    );
  }

  {error && (
  <p className="text-red-600">
    {typeof error === "string" ? error : error.message || "Something went wrong"}
  </p>
  )}

  return (
    <div className="py-4 px-8 md:p-6 xl:px-12 xl:py-8 bg-gray-100 min-h-screen">
      <div className="flex flex-row space-x-2 items-center mb-5" onClick={()=>navigate(-1)}>
        <MdKeyboardBackspace className="text-xl md:text-2xl xl:text-3xl" />
        <h2 className="text-xl xl:text-2xl font-bold">My Cart</h2>
      </div>

      {cartData.length === 0 ? (
        <div className="text-center text-gray-600 flex flex-col space-y-4">
          <p>Your cart is empty.</p>
          <Link to="/">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Products</button>
          </Link>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row gap-6 md:gap-6 xl:gap-8 items-start">
          
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 w-full md:w-1/2 lg:w-2/3">
            {cartData.map((item) => (
              <div key={item.id} className="bg-white p-3 md:p-5 xl:p-6 rounded shadow flex flex-col justify-between gap-3 ">
                
                <div className="flex flex-col md:flex-row items-start gap-2 md:gap-4 w-full">
                  <div className="relative w-full md:w-1/3">
                    <img 
                      src={item.product?.images?.[0].image} 
                      alt={item.product?.productName} 
                      className="rounded-md w-full h-24 md:h-28" 
                    />
                  </div>

                  <div className="flex flex-col space-y-1 w-2/3 ">
                    <Link to={`/productdetail/${item.product?.id}`}>
                    <p className="font-semibold text-sm md:text-base xl:text-lg">
                      {item.product?.productName} {item.product?.model} {item.product?.category?.name}
                    </p>

                    <div className="flex flex-row justify-between items-start text-xs md:text-sm py-2">
                      <p className="text-xs md:text-sm xl:text-base">
                        Color: {item.selectedColor || "N/A"}
                      </p>
                      <p className="text-xs md:text-sm xl:text-base">
                        Size: {item.selectedSize|| "N/A"}
                      </p>
                    </div>

                    <div className="flex items-center space-x-2 justify-between text-xs md:text-sm pt-1">
                      <p className="text-gray-800 ">₹{formatNumber(item.product?.discountedPrice)}</p>
                      <p className="font-semibold text-gray-400 line-through">₹{formatNumber(item.product?.originalPrice)}</p>                     
                      <p className="text-green-600 font-bold">{formatNumber(item.product?.discountPercent)}% OFF</p>
                     
                    </div>
                    </Link>

                  
                  </div>
                </div>

                <div className="flex flex-row justify-between space-x-3 items-center">
                    <div className="flex items-center rounded overflow-hidden w-auto border border-green-700">
                    <button
                     onClick={() => UpdateQuantity(item.product?.id, "decrement",item.selectedColor,item.selectedSize)}
                      className="px-2 "
                      disabled={item.quantity <= 1}
                    >
                      -
                    </button>
                    <span className="px-2 text-xs md:text-sm">{item.quantity}</span>
                    <button
                      onClick={() => UpdateQuantity(item.product?.id, "increment",item.selectedColor,item.selectedSize)}
                      className="px-2 pr-4 md:pr-1"
                    >
                      +
                    </button>
                    </div>
                    <p
                      className={`text-xs md:text-sm font-semibold ${
                        item.product?.stockStatus === "inStock"
                        ? "text-green-600"
                        : item.product?.stockStatus === "lowStock"
                        ? "text-yellow-500"
                        : "text-red-600"
                      }`}
                    >
                      {item.product?.stockStatus === "inStock"
                        ? "In Stock"
                        : item.product?.stockStatus === "lowStock"
                        ? "Low Stock"
                        : "Out of Stock"
                      }
                    </p>


                </div>
                <div className="flex flex-row justify-between items-end w-full gap-2">
                  <button
                    className="text-xs md:text-sm text-[#A63F40] border border-[#A63F40] rounded-md px-2 py-1"
                    onClick={() => {
                      if (isInWishlist(item.product?.id)) {
                        toast.info("Already in wishlist");
                      } else {
                        MOveTOWishlist(item.product?.id);
                      }
                    }}
                    >
                      Move to Wishlist
                  </button>


                  <button
                    className="text-xs md:text-sm text-[#A63F40] border border-[#A63F40] rounded-md px-2 py-1"
                    onClick={() => RemoveFromCart(item.product?.id,item.selectedColor,item.selectedSize)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

         
          <div className="w-full md:w-1/2 lg:w-1/3 bg-white p-6 rounded shadow space-y-4 h-auto">
            <h3 className="text-lg font-semibold">Summary</h3>
            <div className="space-y-1">
              <p className="text-xs md:text-sm xl:text-base">
                Subtotal ({cartData.length} items): ₹{getSubtotal().toLocaleString()}
              </p>
              <p className="font-semibold text-sm md:text-base xl:text-lg">
                Total : ₹{getTotal().toLocaleString()}
              </p>
              <p className="text-xs md:text-sm xl:text-base">
                Saved : ₹{(getSubtotal() - getTotal()).toLocaleString()}
              </p>
              <hr className="my-2" />
              <ul className=" pl-5">
                {cartData.map((item) => (
                <li key={item.id} className="list-disc" >
                  <p className="font-semibold text-xs md:text-sm xl:text-base">
                    {item.product?.productName} {item.product?.model} {item.product?.category?.name} x {item.quantity}
                  </p>
                  
                </li>
                ))}
              </ul>

            </div>
            <div className="flex flex-row md:flex-col xl:flex-row space-x-3 md:space-x-0 xl:space-x-4 text-xs md:text-sm xl:text-base">
            <button className="w-full bg-[#A63F40] text-white py-2 rounded mt-4 md:text-sm xl:text-base"
              onClick={() =>
              navigate("/checkout")}
            >
              CheckOut
            </button>
            <button className="w-full bg-[#A63F40] text-white py-2 rounded mt-4"
                    onClick={handleOnCLickOnAddMoreButton}>
             Add More Items
            </button>
            </div>
            
          </div>
        </div>
      )}
    </div>
  );
}
